import { render, staticRenderFns } from "./company-business-category-modal.vue?vue&type=template&id=a54656c0"
import script from "./company-business-category-modal.vue?vue&type=script&lang=js"
export * from "./company-business-category-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports